export default __webpack_public_path__ + "static/media/pantry2-before1-2048w.a15b68a8.png";